import { useContext } from "react";
import { Box, Divider, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "src/Utils/Context/UserContext";
import { useOrganization } from "src/data/admin/queries/organization";
import { isOrganizationViewEnabled } from "src/helpers/FeatureCapabilityConfig";
import { NoAccess } from "src/design";
import { OrganizationSummary } from "./components/OrganizationSummary";
import { colorTextSecondary, colorBorder } from "src/design/tokens";

const MyOrganization = () => {
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const organizationId = user?.organizationId ?? null;
  const { data: organization, isLoading } = useOrganization(organizationId ?? "");

  if (!isOrganizationViewEnabled(user)) {
    return <NoAccess />;
  }

  const TABS = [
    { label: t("myOrganization.tabs.staff"), path: "staff" },
    { label: t("myOrganization.tabs.roles"), path: "roles" },
  ];

  return (
    <Box display="flex" flexDirection="column" width="100%" gap={3}>
      <OrganizationSummary organization={organization} isLoading={isLoading} />

      <Box sx={{ borderBottom: `1px solid ${colorBorder}`, pb: 2 }}>
        <Typography variant="overline" color="text.secondary" sx={{ px: 1 }}>
          {t("myOrganization.pageTitle")}
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <List
          disablePadding
          sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 1 }}
        >
          {TABS.map((tab) => {
            const active = pathname.includes(`/my-organization/${tab.path}`);
            return (
              <ListItemButton
                key={tab.path}
                selected={active}
                onClick={() => navigate(tab.path)}
                sx={{ borderRadius: 1, width: "auto" }}
              >
                <ListItemText
                  primary={tab.label}
                  primaryTypographyProps={{
                    fontSize: 14,
                    textAlign: "center",
                    color: active ? "inherit" : colorTextSecondary,
                  }}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>

      <Box flex={1}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MyOrganization;
